/* eslint-disable react/prop-types */
import { colors, strCode, tableDataStatuses } from "../../../consts";
import { t } from "../../../services";
import { dateUtil } from "../../../utils";

import {
  TextOverflowWrapper,
  StatusIndicator,
  GradientLoader,
  TextButton,
  DropdownButton
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { DuplicateButtonWrapper } from "./styled";

export const ConsentsTableColumns = [
  {
    Header: strCode.VERSION_TITLE,
    accessor: "version",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`50px`} justifyContent="flex-end">
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={50} height={24} animationDuration={48} />
            ) : (
              cell.value?.toString()
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.MODIFIED_BY_TITLE,
    accessor: "modifiedBy",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={"170px"}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={140} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ACTIVATED_TITLE,
    accessor: "activatedAtTs",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`160px`}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={140} height={24} animationDuration={40} />
            ) : (
              <p
                style={{
                  color: colors.RAISIN_70,
                  whiteSpace: "pre"
                }}
                dangerouslySetInnerHTML={{
                  __html: dateUtil.formatDateFromTimestamp(cell.value)
                }}
              />
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.DEACTIVATED_TITLE,
    accessor: "deactivatedAtTs",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`160px`}>
          <TextOverflowWrapper>
            {isLoading ? (
              <GradientLoader width={140} height={24} animationDuration={40} />
            ) : (
              <p
                style={{
                  color: colors.RAISIN_70,
                  whiteSpace: "pre"
                }}
                dangerouslySetInnerHTML={{
                  __html: dateUtil.formatDateFromTimestamp(cell.value)
                }}
              />
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.STATUS_TITLE,
    accessor: "status",
    Cell: ({ cell, isLoading }) => (
      <CellWrapper width={`105px`}>
        {isLoading ? (
          <GradientLoader width={80} height={24} animationDuration={40} />
        ) : (
          <StatusIndicator status={tableDataStatuses[cell.value?.toLowerCase()]} />
        )}
      </CellWrapper>
    )
  },
  {
    id: "duplicate",
    accessor: "id",
    Cell: ({ cell, cellWidth5, callbackFn1: onDuplicate, isLoading }) => (
      <CellWrapper width="100%" minWidth={`${cellWidth5}px`} justifyContent="flex-end">
        <DuplicateButtonWrapper width="123px" mr={16}>
          {isLoading ? (
            <GradientLoader width={140} height={24} animationDuration={40} />
          ) : (
            <DropdownButton title={t(strCode.DUPLICATE_BTN)} optionsWidth={260} secondary>
              <TextButton
                onClick={(e) => {
                  e.stopPropagation();
                  onDuplicate(cell.value, true);
                }}>
                <TextOverflowWrapper style={{ fontWeight: "normal" }}>
                  {t(strCode.DUPLICATE_HERE)}
                </TextOverflowWrapper>
              </TextButton>
              <TextButton
                onClick={(e) => {
                  e.stopPropagation();
                  onDuplicate(cell.value, false);
                }}>
                <TextOverflowWrapper style={{ fontWeight: "normal" }}>
                  {t(strCode.DUPLICATE_TO_ANOTHER_LOCATION)}
                </TextOverflowWrapper>
              </TextButton>
            </DropdownButton>
          )}
        </DuplicateButtonWrapper>
      </CellWrapper>
    )
  }
];
